import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import React, { useRef } from 'react';
import JsonEditor from '../../components/JsonEditor';

const ViewSpecDialog = (props: any) => {
  const jsonSpecEditorRef = useRef<any>();

  const setSpecEditorRef = (instance: any) => {
    if (instance) {
      instance.jsonEditor.expandAll && instance.jsonEditor.expandAll();
      jsonSpecEditorRef.current = instance.jsonEditor;
    } else {
      jsonSpecEditorRef.current = null;
    }
  };

  return (
    <Dialog
      data-id="trailer-dispatch-dialog"
      open={props.dialogOpen}
      onClose={props.handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">View Spec</DialogTitle>
      <DialogContent>
        <JsonEditor setRef={setSpecEditorRef} id="jsonSpecEditor" data={props.specData} view />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleDialogClose} color="primary" variant="outlined">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ViewSpecDialog;
